// @flow
import { UsersActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    usuario: {},
    listaUsuarios: [],
    loading: false,
    error: false,
    formSubmited: false
};

type UsersAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { usuario?: {} | null, listaUsuarios?: [] | null, loading?: boolean, +value ?: boolean };

const Usuarios = (state: State = INIT_STATE, action: UsersAction): any => {
    // console.log(action);
    switch (action.type) {
        case UsersActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case UsersActionTypes.GET_USER: {
                    return {
                        ...state,
                        usuario: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: false
                    };
                }
                case UsersActionTypes.LIST_USERS: {
                    return {
                        ...state,
                        listaUsuarios: action.payload.data,
                        usuario: {},
                        error: false,
                        loading: false,
                        formSubmited: false
                    };
                }
                case UsersActionTypes.ADD_USER: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case UsersActionTypes.UPDATE_USER_SELF:
                case UsersActionTypes.UPDATE_USER: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        usuario: action.payload.data,
                        formSubmited: true
                    };
                }
                case UsersActionTypes.DELETE_USER: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case UsersActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case UsersActionTypes.GET_USER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        usuario: {},
                        loading: false,
                        formSubmited: false
                    };
                }
                case UsersActionTypes.LIST_USERS: {
                    return {
                        ...state,
                        error: true,
                        listaUsuarios: [],
                        usuario: {},
                        loading: false,
                        formSubmited: false
                    };
                }
                case UsersActionTypes.ADD_USER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case UsersActionTypes.UPDATE_USER_SELF:
                case UsersActionTypes.UPDATE_USER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case UsersActionTypes.DELETE_USER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case UsersActionTypes.GET_USER:
            return { ...state, error: false, loading: true };
        case UsersActionTypes.LIST_USERS:
            return { ...state, error: false, loading: true };
        case UsersActionTypes.ADD_USER:
            return { ...state, error: false, loading: false };
        case UsersActionTypes.UPDATE_USER_SELF:
        case UsersActionTypes.UPDATE_USER:
            return { ...state, error: false, loading: false };
        case UsersActionTypes.DELETE_USER:
            return { ...state, error: false, loading: false };
        case UsersActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                usuario: {},
                listaUsuarios: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Usuarios;
